import type { FormValues, MetaValues, TfValue } from '@/types/form';
import {
  FORM_HELP_OVERRIDE_MAP,
  FORM_HELP_SUPPORT_OVERRIDE_MAP,
} from '@/components/react/form/translations';

export const getTkValues = (tfValue?: TfValue) => {
  const tfValues: Record<TfValue, boolean> = {
    analyze_tf: false,
    contractor_tf: false,
    dk_tf: false,
    geo_tf: false,
    gmp_tf: false,
    hire_tf: false,
    manage_tf: false,
    other_tf: false,
    pay_tf: false,
    payrollexp_tf: false,
    recruit_tf: false,
  };
  if (tfValue) {
    tfValues[tfValue] = true;
  }

  return tfValues;
};

export interface SubmitFormValues extends FormValues, MetaValues {
  recruit_tf: boolean;
  hire_tf: boolean;
  contractor_tf: boolean;
  pay_tf: boolean;
  manage_tf: boolean;
  dk_tf: boolean;
  other_tf: boolean;
  support_type: string;
}

export const getSubmitFormValues = (
  value: FormValues,
  metaValues: MetaValues,
) => {
  const mutatedValues: SubmitFormValues = {
    ...value,
    ...metaValues,
    [FORM_HELP_OVERRIDE_MAP[value.howCanWeHelp]]: true,
    support_type: FORM_HELP_SUPPORT_OVERRIDE_MAP[value.supportDummy] || '',
  };
  return mutatedValues;
};
